import React, { useEffect, useRef } from 'react';
import {useSelector} from 'react-redux';
import { Form, Select, Input, Button, Alert, AutoComplete } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useFetchSiteInfo } from './redux/hooks';
import './SearchParameters.less';
import {SIA_IA_STI_SEARCH_PARAMS_KEY} from '../../common/constants';

export default function SearchParameters({ type, onSearch, onReset }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { siteList, fetchSiteInfo, fetchSiteInfoPending } = useFetchSiteInfo();
  const { territoryData } = useSelector(state => state.dashboard);
  const role = territoryData?.role;
  const sellerId = territoryData?.sellerId;

  const getStorageKey = () => `${SIA_IA_STI_SEARCH_PARAMS_KEY}_${type}`;

  //   useEffect(() => {
  //     if (siteList.length === 0) {
  //       fetchSiteInfo(role, sellerId);
  //     }
  //   }, []); // eslint-disable-line

  useEffect(() => {
    if (role && sellerId) {
      fetchSiteInfo(role, sellerId);
    }
  }, [role, sellerId, fetchSiteInfo]);

  // Restore saved search parameters on mount
  useEffect(() => {
    const savedParams = sessionStorage.getItem(getStorageKey());
    if (savedParams) {
      try {
        const parsedParams = JSON.parse(savedParams);
        form.setFieldsValue(parsedParams);
      } catch (error) {
        console.error('Error parsing saved search parameters:', error);
      }
    }
  }, [type]); // eslint-disable-line

  // Populate Full Site text on UI
  const handleSiteBlur = () => {
  const val = form.getFieldValue('site');
  if (!val || !siteList.length) return;
  
  const siteNum = String(val).split('-')[0].trim();
  const match = siteList.find(s => String(s.site_nbr) === siteNum);
  
  if (match && val !== `${match.site_nbr} - ${match.site_desc}`) {
    const fullValue = `${match.site_nbr} - ${match.site_desc}`;
    form.setFieldsValue({ site: fullValue });  
  }
};

  // const handleSearch = (values) => {
  //   console.log('SearchParameters - handleSearch values:', values);
    
  //   // Save search parameters to session storage
  //   sessionStorage.setItem(getStorageKey(), JSON.stringify(values));
    
  //   if (onSearch) {
  //     onSearch(values);
  //   }
  // };
 
  const handleSearch = values => {
    const normalizedSite = values.site ? String(values.site).split('-')[0].trim() : values.site;
    const submitValues = { ...values, site: normalizedSite };
 
    sessionStorage.setItem(getStorageKey(), JSON.stringify(values)); 
    if (onSearch) {
      onSearch(submitValues); 
    }
  };

  const handleReset = () => {
    console.log('SearchParameters - handleReset');
    form.resetFields();
    
    // Clear saved search parameters
    sessionStorage.removeItem(getStorageKey());
    
    // Call parent's reset handler
    if (onReset) {
      onReset();
    }
  };

  const getAlertMessage = () => {
    if (type === 'item') {
      return t('Enter a site and item number to search for item availability information.');
    }
    return t('Enter a site and ship to number to search for Ship-To information including customer details and configuration.');
  };

  const getInputLabel = () => {
    return type === 'item' ? t('Item Number') : t('Ship-To Number');
  };

  const getInputPlaceholder = () => {
    return type === 'item' ? t('Enter item number') : t('Enter ship-to number');
  };

  const getInputName = () => {
    return type === 'item' ? 'itemNumber' : 'shipToNumber';
  };

  return (
    <div className="search-parameters">
      <Alert
        message={getAlertMessage()}
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        className="search-alert"
      />
      <div className="search-form-container">
        <h4>{t('Search Parameters')}</h4>
        <Form
          form={form}
          layout="inline"
          onFinish={handleSearch}
          className="search-form"
        >
          <Form.Item
            name="site"
            label={t('Site')}
            rules={[{ required: true, message: t('Please select Site!') },
            {
              validator: (_, v) =>
                !v || siteList.some(s => String(s.site_nbr) === String(v).split('-')[0].trim())
                  ? Promise.resolve()
                  : Promise.reject(new Error(t('Please select a valid Site from the dropdown'))),
            },
            ]}
            className="form-item-site"
          >
            {/* <Select
              showSearch
              placeholder={t('Select a Site')}
              loading={fetchSiteInfoPending}
              style={{ width: 250 }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {siteList.map(item => {
                const siteNbr = item.site_nbr;
                const siteDesc = item.site_desc;
                return (
                  <Select.Option key={siteNbr} value={siteNbr}>
                    {`${siteNbr} - ${siteDesc}`}
                  </Select.Option>
                );
              })}
            </Select> */}

            <AutoComplete
              allowClear
              placeholder={t('Select a Site')}
              loading={fetchSiteInfoPending}
              style={{ width: 250 }}
              onBlur={handleSiteBlur}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={siteList.map(item => ({
                value: `${item.site_nbr} - ${item.site_desc}`,
                label: `${item.site_nbr} - ${item.site_desc}`
              }))}
            />
          </Form.Item>

          <Form.Item
            name={getInputName()}
            label={getInputLabel()}
            rules={[{ required: true, message: `Please enter ${getInputLabel()}!` }]}
            className="form-item-number"
          >
            <Input placeholder={getInputPlaceholder()} style={{ width: 250 }} />
          </Form.Item>

          <div className="button-wrapper">
            <Button type="primary" htmlType="submit" className="search-btn">
              {t('Search')}
            </Button>
            <Button onClick={handleReset} className="reset-btn">
              {t('Reset')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}


